import { SmartModel, Shark } from "shark-mvc";

class ActiveItems extends SmartModel {
	constructor (data) {
		super();
		
		this.currActivityId = "";
		this.currProjectId = "";
		this.newProjectClientGuid = "";
		this.newProjectOrganizationGuid = "";
		this.newProjectTags = "";
		this.projectSearchKey = "";
		this.projectSortField = "lastActivityAt";
		// this.showClosedProject = false;
		// this.showClosedTasks = false;
		this.taskSearchKey = "";
		this.taskSortField = "lastActivityAt";
				
		if (data) {
			this.import(data);
		}
	}

	import (data, options) {
		super.import(data, options);

		Shark.set({
			// Dave: Va a sparire, per ora è presente nelle stats:
			__projectFilterActiveCSSClass: this.projectSearchKey === "" ? "" : "active-filter",
			__taskFilterActiveCSSClass: this.taskSearchKey === "" ? "" : "active-filter",
		});
	}

	onDataChanged () {
		// console.log("ActiveItems:", this);
		localStorage.setItem("applicationSettings", JSON.stringify(this.export()));
	}

	onNewProjectOrganizationGuidChanged () {
		// console.log(this);

		const { clientList } = Shark.get();
		const newProjectClientList = clientList.filter(item => item.organizationGuid === this.newProjectOrganizationGuid);

		Shark.set({
			newProjectClientList,
		});
	}
}

Shark.registerModel("ActiveItems", ActiveItems);

export default ActiveItems;
